import {styled} from '@mui/material/styles'

export const SocialLink = styled('a', {
    name: 'Footer',
    slot: 'SocialLink',
    shouldForwardProp: (prop) => prop !== 'isHomepage'
})(({theme, isHomepage}) => ({
    color: isHomepage ? '#333' : 'white',
    cursor: 'pointer'
}))